import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FRONTEND_LINKS } from "../../Constants/FrontendLinks";
import logo from "./logo.png";
const RMInactive = (props) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();



    function isMobile() {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    }

    useEffect(() => {
        isMobile();
        props.setNavPage(false);
    }, []);


    return (
        <div style={{
            backgroundColor: "#F1F7FF",
            minHeight: "100dvh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            fontFamily: "Arial, sans-serif",
            padding: "32px 10px 16px 10px"
        }}>
            <div style={{
                display: "flex", flexDirection: "column", alignItems: "center", gap: "4px", marginTop: "20px"
            }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <img src={logo} alt="Logo" style={{ width: "50px", height: "auto" }} />
                    <div
                        style={
                            {
                                display: "flex",
                                alignItems: "baseline",
                                gap: "4px",
                            }
                        }
                    >
                        <h2 style={{
                            margin: 0, fontSize: "38px", color: "#007bff", fontFamily: "Montserrat, sans-serif", fontWeight: "lighter"
                        }}>MCP</h2>
                        <span style={{
                            fontSize: "14px", color: "#777", fontWeight: "bold", fontFamily: "Arial, sans-serif"
                        }}>v1.1.2</span>
                    </div>
                </div>
                <p style={{
                    fontSize: "14px", fontWeight: "bold", color: "#888", margin: 0, fontFamily: "Montserrat, sans-serif",
                }}>
                    MOBERG CLINICAL PLATFORM
                </p>
            </div>

            <div style={{
                backgroundColor: "#fff",

                borderRadius: "10px",
                // boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                width: "100%",
                maxWidth: "400px",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
            }}>
                <h1 style={{
                    fontSize: "24px", marginBottom: "20px", fontWeight: "bold", fontFamily: "Montserrat, sans-serif", color: "#515151", textAlign: "center", marginTop: "24px"
                }}>Session Timeout</h1>

                <p style={{ fontSize: "16px", marginBottom: "20px", fontFamily: "Montserrat, sans-serif", color: "#5B5B5B", textAlign: "center" }}>
                    You have been logged out due to inactivity.
                </p>
                

                <button
                    onClick={() => navigate(FRONTEND_LINKS.MAIN)}
                    disabled={isLoading}
                    style={{
                        ...buttonStyle,
                        opacity: 1,
                        cursor: "pointer",
                        
                    }}
                >
                    Click here to log in
                </button>

            </div>

            <div style={{ width: "100%", maxWidth: "400px", textAlign: "center", marginTop: "20px" }}>
                <hr style={{ border: "none", borderTop: "1px solid #747474", marginBottom: "8px" }} />
                <p style={{ fontSize: "12px", color: "#777", margin: 0 }}>
                    Copyright © 2025 Moberg Analytics, Inc. All Rights Reserved |
                    <a href="https://moberganalytics.com/privacy-policy" style={{ color: "#007bff", textDecoration: "none", marginLeft: "4px" }}>Privacy</a>
                </p>
            </div>
        </div>
    );
};

const labelStyle = {
    fontSize: "14px",
    fontWeight: "600",
    display: "block",
    marginBottom: "5px",
    marginTop: "16px",
    fontFamily: "Montserrat, sans-serif",
};

const inputStyle = {
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "14px",
    boxSizing: "border-box"
};

const buttonStyle = {
    // width: "100%",
    padding: "12px",
    backgroundColor: "#007bff",
    color: "white",
    fontSize: "16px",
    fontWeight: "bold",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    margin: "0 24px 24px 24px",

};


export default RMInactive;
